import _ from 'lodash';

class ArticleController {
  constructor($sce, $location, DataService) {
    "ngInject";
    this.article = {};

    this.test = 'hi';

    let self = this;
    DataService.getNews().then(function(response) {
      self.moreNews = response.data;
      self.article = _.find(response.data, ['titleUrl', $location.search().article]);

      if(self.article) {
        self.article.description = $sce.trustAsHtml(self.article.description);
      }
    });
  }
}

export default ArticleController;



// WEBPACK FOOTER //
// ./app/components/article/article.controller.js